import {FC, useEffect, useMemo, useRef, useState} from 'react'
import {Dropdown, Form, Modal, OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import React from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import '../../../../../app/Components/Style/Components.scss'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import moment from 'moment-timezone'
import QuickMessageDrawerInner from '../../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import {
  DeleteData,
  GetContectData,
  optInContact,
  optoutContact,
} from '../AllContactsList/SubscriberSlice/SubscriberSlice'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {
  ContactDetail,
  ContactDetailClickThrough,
  ContactDetailMessage,
} from '../../../../../services/cellcast.v2.types'
import {Group} from '../../../../../services/cellcast.type'
import {
  useLazyGetContactInformationClickThroughQuery,
  useLazyGetContactInformationMessageQuery,
  useLazyGetContactInformationQuery,
} from '../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'
import {totalUnsubscribedContactCount} from '../../new-message/BulkMessageSlice/BulkMessageSlice'

type ContactDetailPanelProps = {
  show: boolean
  contactId: string
  group: Group | undefined
  handleClose: () => void
  setEditPopup: (data: any) => void
}

const ContactDetailPanel: FC<ContactDetailPanelProps> = (props) => {
  const {show, contactId, group, handleClose, setEditPopup} = props

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [quickMessage, setQuickmessage] = useState(false)
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()

  const [contactData, setContactData] = useState<ContactDetail>()
  const [contactMessage, setContactMessage] = useState<ContactDetailMessage>()
  const [contactClickThrough, setContactClickThrough] = useState<ContactDetailClickThrough>()

  const [getContactData, {isLoading: getContactDataLoading, isFetching: getContactDataFetching}] =
    useLazyGetContactInformationQuery()
  const [
    getContactMessage,
    {isLoading: getContactMessageLoading, isFetching: getContactMessageFetching},
  ] = useLazyGetContactInformationMessageQuery()
  const [
    getContactClickThrough,
    {isLoading: getContactClickThroughLoading, isFetching: getContactClickThroughFetching},
  ] = useLazyGetContactInformationClickThroughQuery()

  // first load
  useEffect(() => {
    if (show === true && contactId !== '') {
      getContactData(contactId).then((res) => {
        if ('data' in res) {
          if (res.data?.error && Object.keys(res.data?.error).length > 0) {
            toast.error(res?.data?.message)
          } else if (res.data) {
            setContactData(res.data.data)
          }
        } else if ('error' in res) {
          toast.error(res.error)
        }
      })
      getContactMessage(contactId).then((res) => {
        if ('data' in res) {
          if (res.data?.error && Object.keys(res.data?.error).length > 0) {
            toast.error(res?.data?.message)
          } else if (res.data) {
            setContactMessage(res.data.data)
          }
        } else if ('error' in res) {
          toast.error(res.error)
        }
      })
      getContactClickThrough(contactId).then((res) => {
        if ('data' in res) {
          if (res.data?.error && Object.keys(res.data?.error).length > 0) {
            toast.error(res?.data?.message)
          } else if (res.data) {
            setContactClickThrough(res.data.data)
          }
        } else if ('error' in res) {
          toast.error(res.error)
        }
      })
    }
  }, [show])

  const dbOptions = group?.fields || []

  useEffect(() => {
    if (confirm === true) {
      dispatch(DeleteData(deleteIds))
      setConfirm(false)
      handleClose()
    }
  }, [confirm])

  const checkField = () => {
    let fields = ['First Name', 'Full Name', 'Last Name']
    if (dbOptions?.find((val: any) => fields.includes(val)) == undefined) {
      return false
    } else {
      return true
    }
  }

  const checkUnsubscribeContact = (list: any) => {
    let tempList = []
    tempList = list?.map((key: any) =>
      key?.isBlockedByUser || key?.isBlocked ? 'Unsubscribed' : 'Subscribed'
    )
    return tempList?.every((key: any) => key === 'Unsubscribed')
  }

  const checkSubscribeContact = (list: any) => {
    let tempList = []
    tempList = list?.map((key: any) =>
      key?.isBlockedByUser || key?.isBlocked ? 'Unsubscribed' : 'Subscribed'
    )
    return tempList?.every((key: any) => key == 'Subscribed')
  }

  const handleDeleteAll = () => {
    setOpen(true)
    setDeleteIds({contact_ids: [contactData?._id], group: contactData?.group?._id})
  }

  const sendQuickMessage = useMemo(
    () => (
      <QuickMessageDrawerInner
        show={quickMessage}
        handleClose={() => setQuickmessage(false)}
        contacts={[{value: contactData?.number || '', label: contactData?.number}]}
      />
    ),
    [quickMessage]
  )

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete contact?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  return (
    <React.Fragment>
      {sendQuickMessage}
      {confirmation}
      <Modal
        show={show}
        onHide={async () => {
          handleClose()
        }}
        className={`quickMessageModal ${show ? 'right' : 'left'} `}
        dialogClassName={`modal-dialog-centered mw-500px w-100 nopreviweQuickMessage`}
      >
        <div className='card w-100 rounded-0' id='kt_drawer_chat_messenger'>
          <div
            className='card-header pe-5 quick-message-header'
            id='kt_drawer_chat_messenger_header'
          >
            <div className='card-title'>
              <div className='d-flex justify-content-center flex-column me-3'>
                <a
                  href='#'
                  className='fs-4 fw-bolder text-gray-900 text-hover-primary m-0 lh-1 d-flex align-items-center gap-2 '
                  style={{textDecoration: 'none', margin: '0px !important'}}
                >
                  {contactData?.fields?.findIndex((val: any) => val?.name === 'First Name') !== -1
                    ? contactData?.fields?.[
                        contactData?.fields?.findIndex((val: any) => val?.name === 'First Name')
                      ]?.value
                    : contactData?.number}
                </a>
              </div>
            </div>

            <div className='card-toolbar'>
              <div
                className='btn btn-sm btn-icon btn-active-light-primary'
                id='kt_drawer_chat_close'
                onClick={handleClose}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
              </div>
            </div>
          </div>

          <form className='form quick-message-form' noValidate>
            <div className='card-body '>
              <div className='QuickMsgLeft'>
                <div className='d-flex flex-wrap flex-sm-nowrap flex-column align-items-center'>
                  <div className='flex-grow-1 w-100'>
                    <div className='d-flex justify-content-between align-items-start flex-wrap mb-2 justify-content-center'>
                      <div className='d-flex flex-column align-items-center w-100'>
                        <div className='d-flex align-items-start mb-2 w-100 flex-column '>
                          <div className=' me-1 d-flex align-items-center justify-content-between w-100 '>
                            <div className='text-hover-primary text-gray-900  fs-2 fw-bolder'>
                              Activity overview
                            </div>
                            <div className='m-0'>
                              <div className='me-0'>
                                <Dropdown>
                                  <Dropdown.Toggle className='btn btn-primary my-2 m-sm-0'>
                                    Action
                                    <KTSVG
                                      path='/media/icons/duotune/arrows/down-white.svg'
                                      className='svg-icon-6 ms-3'
                                    />
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu className='w-250px'>
                                    <label className='text-muted p-3 pb-3 fs-7'>ACTIONS</label>
                                    <Dropdown.Item
                                      onClick={() => {
                                        navigate(`/new-message`, {
                                          state: {
                                            selectedType: 'contacts',
                                            data: [contactData?.number],
                                          },
                                        })
                                      }}
                                      className='menu-content  p-3 fs-8 text-uppercase'
                                    >
                                      Bulk Message
                                    </Dropdown.Item>
                                    {AuthenticateUser('send-quick-sms') && (
                                      <Dropdown.Item
                                        onClick={() => {
                                          setQuickmessage(true)
                                        }}
                                        className='menu-content   p-3 fs-8 text-uppercase'
                                      >
                                        Send quick message
                                      </Dropdown.Item>
                                    )}

                                    {AuthenticateUser('edit-contact') && (
                                      <>
                                        <label className='text-muted p-3 pb-3 pt-7 fs-7'>
                                          CONTACT MANAGEMENT
                                        </label>
                                        {checkSubscribeContact([contactData]) ||
                                        (!checkSubscribeContact([contactData]) &&
                                          !checkUnsubscribeContact([contactData])) ? (
                                          <Dropdown.Item
                                            onClick={() => {
                                              dispatch(
                                                optoutContact({
                                                  data: {
                                                    ids: [contactData?.contact?._id],
                                                  },
                                                  id: contactData?.group?._id,
                                                })
                                              ).then(() => {
                                                dispatch(
                                                  GetContectData({
                                                    payload: {
                                                      receiver: contactData?.number,
                                                      contcatId: contactData?.contact?._id,
                                                    },
                                                  })
                                                )
                                              })

                                              contactData?.group?._id &&
                                                dispatch(
                                                  totalUnsubscribedContactCount(
                                                    contactData?.group?._id
                                                  )
                                                )
                                            }}
                                            className='menu-content  p-3 fs-8 text-uppercase'
                                          >
                                            Unsubscribed contact
                                          </Dropdown.Item>
                                        ) : null}
                                      </>
                                    )}
                                    {checkUnsubscribeContact([contactData]) ||
                                    (!checkSubscribeContact([contactData]) &&
                                      !checkUnsubscribeContact([contactData])) ? (
                                      <Dropdown.Item
                                        onClick={() => {
                                          dispatch(
                                            optInContact({
                                              data: {
                                                ids: [contactData?.contact?._id],
                                              },
                                              id: contactData?.group?._id,
                                            })
                                          ).then(() => {
                                            dispatch(
                                              GetContectData({
                                                payload: {
                                                  receiver: contactData?.number,
                                                  contcatId: contactData?.contact?._id,
                                                },
                                              })
                                            )
                                          })
                                          contactData?.group?._id &&
                                            dispatch(
                                              totalUnsubscribedContactCount(contactData?.group?._id)
                                            )
                                        }}
                                        className='menu-content  p-3 fs-8 text-uppercase'
                                      >
                                        Subscribed contact
                                      </Dropdown.Item>
                                    ) : null}
                                    {AuthenticateUser('edit-contact') && (
                                      <Dropdown.Item
                                        onClick={async () => {
                                          const mergedArray: any = contactData?.group?.fields
                                            ? [...contactData?.group?.fields]
                                            : []

                                          const finalFieldData = await mergedArray?.map(
                                            (key: any) => {
                                              if (
                                                contactData?.fields?.find(
                                                  (val2: any) => val2?.name == key
                                                ) !== undefined
                                              ) {
                                                return contactData?.fields?.find(
                                                  (val2: any) => val2?.name == key
                                                )
                                              } else {
                                                return {name: key, value: ''}
                                              }
                                            }
                                          )
                                          setEditPopup({
                                            data: finalFieldData,
                                            toggle: true,
                                            number: contactData?.number,
                                            _id: contactData?._id,
                                            tags: contactData?.tags,
                                            group: contactData?.group,
                                          })
                                          handleClose()
                                        }}
                                        className='menu-content   p-3 fs-8 text-uppercase '
                                      >
                                        Edit Contact
                                      </Dropdown.Item>
                                    )}
                                    {AuthenticateUser('delete-contact') && (
                                      <Dropdown.Item
                                        onClick={() => {
                                          handleDeleteAll()
                                        }}
                                        className='menu-content   p-3 fs-8 text-uppercase text-danger'
                                      >
                                        Delete Contact
                                      </Dropdown.Item>
                                    )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                          </div>
                          <hr
                            className='hr'
                            style={{
                              width: '100%',
                              backgroundColor: '#e3e3e3',
                              height: '2px',
                            }}
                          ></hr>
                        </div>
                      </div>
                    </div>
                    <div className='d-flex flex-wrap flex-stack'>
                      <div className='d-flex flex-column flex-grow-1'>
                        <div className='d-flex align-items-start mb-2 w-100 flex-column '>
                          <div className=' me-1 d-flex align-items-center justify-content-between w-100 '>
                            <div className='text-hover-primary text-gray-900  fs-4 fw-bolder'>
                              Message Activity
                            </div>
                          </div>
                          <hr
                            className='hr'
                            style={{
                              width: '100%',
                              backgroundColor: '#e3e3e3',
                              height: '2px',
                            }}
                          ></hr>
                        </div>
                        <div className='d-flex flex-wrap'>
                          <div className='d-flex flex-column justify-content-center align-items-center border border-gray-300 border-dashed rounded  py-3 px-4 me-4 mb-3 min-w-25'>
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                              <div
                                className='fs-2 fw-bolder me-2 text-gray-600'
                                data-kt-countup='true'
                                data-kt-countup-value={47}
                              >
                                {getContactMessageLoading || getContactMessageFetching ? (
                                  <Spinner size='sm' animation='grow' />
                                ) : contactMessage ? (
                                  contactMessage?.allSendMessage
                                ) : (
                                  0
                                )}
                              </div>
                            </div>
                            <div className='fw-bold fs-6 text-gray-400'>All Send Message</div>
                          </div>
                          <div className='d-flex flex-column justify-content-center align-items-center border border-gray-300 border-dashed rounded  py-3 px-4 me-4 mb-3 min-w-25'>
                            <div className='d-flex justify-content-center align-items-center'>
                              <div
                                className='fs-2 fw-bolder me-2 text-gray-600'
                                data-kt-countup='true'
                                data-kt-countup-value={34}
                              >
                                {getContactMessageLoading || getContactMessageFetching ? (
                                  <Spinner size='sm' animation='grow' />
                                ) : contactMessage ? (
                                  contactMessage?.receivedMessage
                                ) : (
                                  0
                                )}
                              </div>
                            </div>
                            <div className='fw-bold fs-6 text-gray-400'>Received</div>
                          </div>
                          <div className='d-flex flex-column justify-content-center align-items-center border border-gray-300 border-dashed rounded  py-3 px-4 me-4 mb-3 min-w-25'>
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                              <div
                                className='fs-2 fw-bolder me-2 text-gray-600'
                                data-kt-countup='true'
                                data-kt-countup-value={13}
                              >
                                {getContactMessageLoading || getContactMessageFetching ? (
                                  <Spinner size='sm' animation='grow' />
                                ) : contactMessage ? (
                                  contactMessage?.repliesMessage
                                ) : (
                                  0
                                )}
                              </div>
                            </div>
                            <div className='fw-bold fs-6 text-gray-400'>Replies</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='d-flex flex-wrap flex-stack'>
                      <div className='d-flex flex-column flex-grow-1'>
                        <div className='d-flex align-items-start mb-2 w-100 flex-column '>
                          <div className=' me-1 d-flex align-items-center justify-content-between w-100 '>
                            <div className='text-hover-primary text-gray-900  fs-4 fw-bolder'>
                              Click Through Activity
                            </div>
                          </div>
                          <hr
                            className='hr'
                            style={{
                              width: '100%',
                              backgroundColor: '#e3e3e3',
                              height: '2px',
                            }}
                          ></hr>
                        </div>
                        <div className='d-flex flex-wrap'>
                          <div className='d-flex flex-column justify-content-center align-items-center border border-gray-300 border-dashed rounded  py-3 px-4 me-4 mb-3 min-w-25'>
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                              <div
                                className='fs-2 fw-bolder me-2 text-gray-600'
                                data-kt-countup='true'
                                data-kt-countup-value={47}
                              >
                                {getContactClickThroughLoading || getContactClickThroughLoading ? (
                                  <Spinner size='sm' animation='grow' />
                                ) : contactClickThrough ? (
                                  contactClickThrough?.total
                                ) : (
                                  0
                                )}
                              </div>
                            </div>
                            <div className='fw-bold fs-6 text-gray-400'>All</div>
                          </div>
                          <div className='d-flex flex-column justify-content-center align-items-center border border-gray-300 border-dashed rounded  py-3 px-4 me-4 mb-3 min-w-25'>
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                              <div
                                className='fs-2 fw-bolder me-2 text-gray-600'
                                data-kt-countup='true'
                                data-kt-countup-value={34}
                              >
                                {getContactClickThroughLoading || getContactClickThroughLoading ? (
                                  <Spinner size='sm' animation='grow' />
                                ) : contactClickThrough ? (
                                  contactClickThrough?.shortLinkClick
                                ) : (
                                  0
                                )}
                              </div>
                            </div>
                            <div className='fw-bold fs-6 text-gray-400'>Short Link</div>
                          </div>
                          <div className='d-flex flex-column justify-content-center align-items-center border border-gray-300 border-dashed rounded  py-3 px-4 me-4 mb-3 min-w-25'>
                            <div className='d-flex flex-column justify-content-center align-items-center'>
                              <div
                                className='fs-2 fw-bolder me-2 text-gray-600'
                                data-kt-countup='true'
                                data-kt-countup-value={13}
                              >
                                {getContactClickThroughLoading || getContactClickThroughLoading ? (
                                  <Spinner size='sm' animation='grow' />
                                ) : contactClickThrough ? (
                                  contactClickThrough?.landingPageClick
                                ) : (
                                  0
                                )}
                              </div>
                            </div>
                            <div className='fw-bold fs-6 text-gray-400'>Landing Page</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='d-flex mb-2 contact-accodian'>
                  <div className='accordion w-100' id='kt_accordion_1'>
                    {getContactDataLoading || getContactDataFetching ? (
                      <div
                        className='d-flex flex-column justify-content-center align-items-center'
                        style={{height: '30vh'}}
                      >
                        <Spinner animation='grow' />
                        <span className='fw-bold fs-8 text-gray-400 mt-5'>fetching data</span>
                      </div>
                    ) : (
                      <div className='accordion-item border-0'>
                        <h2
                          className='accordion-header align-items-baseline gap-19 border-bottom pb-3 d-flex'
                          id='kt_accordion_1_header_1'
                        >
                          <button
                            className='accordion-button bg-transparent fs-4 fw-bolder collapsed py-3 px-4 mt-4'
                            type='button'
                            data-bs-toggle='collapse'
                            data-bs-target='#kt_accordion_1_body_1'
                            aria-expanded='false'
                            aria-controls='kt_accordion_1_body_1'
                          >
                            <span className='d-inline-flex me-4'>Contact</span>
                          </button>
                        </h2>
                        <div
                          id='kt_accordion_1_body_1'
                          className='accordion-collapse collapse'
                          aria-labelledby='kt_accordion_1_header_1'
                          data-bs-parent='#kt_accordion_1'
                        >
                          <div className='accordion-body px-2'>
                            <div className='card-body p-0'>
                              {/* <span className='badge badge-light-info mb-5'>Golden user</span> */}
                              <div className='row mb-4'>
                                <label className='col-lg-12 fw-bolder text-gray-800'>Mobile</label>
                                <div className='col-lg-12'>
                                  <span className='fw-semibold fs-6 text-muted'>
                                    {contactData?.number}
                                  </span>
                                </div>
                              </div>
                              <div className='row mb-4'>
                                <label className='col-lg-12 fw-bolder text-gray-800'>Tags</label>
                                <div className='col-lg-12 d-flex gap-2 align-items-center flex-wrap'>
                                  {contactData &&
                                  contactData?.tags?.filter((key: any) => {
                                    if (key?.type) {
                                      return key?.isHidden === false && key?.type !== 'list'
                                    }
                                    return key?.isHidden === false
                                  })?.length > 0 ? (
                                    contactData?.tags
                                      ?.filter((key: any) => key?.isHidden === false)
                                      ?.map((key: any, i: number) => (
                                        <div
                                          key={i}
                                          className='fw-semibold fs-6 text-muted inbox-tags'
                                          style={{
                                            width: 'fit-content',
                                          }}
                                        >
                                          {key?.name}
                                        </div>
                                      ))
                                  ) : (
                                    <span className='fw-semibold fs-6 text-muted'>--</span>
                                  )}
                                </div>
                              </div>
                              <div className='row mb-4'>
                                <label className='col-lg-12 fw-bolder text-gray-800'>Status</label>
                                <div className='col-lg-12'>
                                  <span className='fw-semibold fs-6 text-muted'>
                                    {contactData?.isBlockedByUser || contactData?.isBlocked
                                      ? 'Unsubscribed'
                                      : 'Subscribed'}
                                  </span>
                                </div>
                              </div>
                              {checkField() && dbOptions?.includes('First Name') && (
                                <div className='row mb-4'>
                                  <label className='col-lg-12 fw-bolder text-gray-800'>
                                    First Name
                                  </label>
                                  <div className='col-lg-12'>
                                    <span className='fw-semibold fs-6 text-muted'>
                                      {contactData?.fields?.findIndex(
                                        (val: any) => val?.name === 'First Name'
                                      ) !== -1
                                        ? contactData?.fields?.[
                                            contactData?.fields?.findIndex(
                                              (val: any) => val?.name === 'First Name'
                                            )
                                          ]?.value || '--'
                                        : '--'}
                                    </span>
                                  </div>
                                </div>
                              )}
                              {checkField() && dbOptions?.includes('Last Name') && (
                                <div className='row mb-4'>
                                  <label className='col-lg-12 fw-bolder text-gray-800'>
                                    Last Name
                                  </label>
                                  <div className='col-lg-12'>
                                    <span className='fw-semibold fs-6 text-muted'>
                                      {contactData?.fields?.findIndex(
                                        (val: any) => val?.name === 'Last Name'
                                      ) !== -1
                                        ? contactData?.fields?.[
                                            contactData?.fields?.findIndex(
                                              (val: any) => val?.name === 'Last Name'
                                            )
                                          ]?.value || '--'
                                        : '--'}
                                    </span>
                                  </div>
                                </div>
                              )}
                              {checkField() && dbOptions?.includes('Full Name') && (
                                <div className='row mb-4'>
                                  <label className='col-lg-12 fw-bolder text-gray-800'>
                                    Full Name
                                  </label>
                                  <div className='col-lg-12'>
                                    <span className='fw-semibold fs-6 text-muted'>
                                      {contactData?.fields?.findIndex(
                                        (val: any) => val?.name === 'Full Name'
                                      ) !== -1
                                        ? contactData?.fields?.[
                                            contactData?.fields?.findIndex(
                                              (val: any) => val?.name === 'Full Name'
                                            )
                                          ]?.value || '--'
                                        : '--'}
                                    </span>
                                  </div>
                                </div>
                              )}

                              {dbOptions?.map((val: any, index: number) => {
                                let check = contactData?.fields?.map((key: any) => key?.name)
                                if (!['First Name', 'Full Name', 'Last Name']?.includes(val)) {
                                  if (check?.includes(val)) {
                                    return (
                                      <>
                                        <div key={index} className='row mb-4'>
                                          <label className='col-lg-12 fw-bolder text-gray-800'>
                                            {val}
                                          </label>
                                          <div className='col-lg-12'>
                                            <span className='fw-semibold fs-6 text-muted'>
                                              {contactData?.fields?.find(
                                                (key: any) => key?.name == val
                                              )?.value || '--'}
                                            </span>
                                          </div>
                                        </div>
                                      </>
                                    )
                                  } else {
                                    return (
                                      <>
                                        <div key={index} className='row mb-4'>
                                          <label className='col-lg-12 fw-bolder text-gray-800'>
                                            {val}
                                          </label>
                                          <div className='col-lg-12'>
                                            <span className='fw-semibold fs-6 text-muted'>--</span>
                                          </div>
                                        </div>
                                      </>
                                    )
                                  }
                                }
                              })}

                              <div className='row mb-4'>
                                <label className='col-lg-12 fw-bolder text-gray-800'>
                                  Date Added
                                </label>
                                <div className='col-lg-12'>
                                  <span className='fw-semibold fs-6 text-muted'>
                                    {moment(contactData?.createdAt).format('DD/MM/YYYY')}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default ContactDetailPanel
